import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import NavBar from "../components/NavBar";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const u = await login(email, password);
      const buy = params.get("buy");
      if (u.role === "admin") nav("/admin");
      else nav(buy ? `/dashboard?buy=${buy}` : "/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page">
      <NavBar />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="label-eyebrow mb-3">AUTH / 01</div>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight mb-8">Customer login</h1>
        <form onSubmit={submit} className="space-y-4 tech-card p-6" data-testid="login-form">
          <div>
            <label className="ribbon block mb-2">Email</label>
            <input className="input" type="email" required value={email}
                   onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="ribbon block mb-2">Password</label>
            <input className="input" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {err && <div className="text-sm text-red-700 border border-red-700 p-2" data-testid="login-error">{err}</div>}
          <button className="btn btn-primary w-full justify-center" disabled={loading} data-testid="login-submit">
            {loading ? "..." : "Sign in →"}
          </button>
        </form>
        <p className="mt-4 text-sm text-black/70">
          No account? <Link to="/signup" className="underline" data-testid="login-to-signup">Create one</Link>.
        </p>
      </div>
    </div>
  );
}
